import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoanStatements = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#68c7ff",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "LoanStatements",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 16660",
					d: "M2.5 0.5H10.3789C10.644 0.50006 10.8985 0.605486 11.0859 0.792969L14.207 3.91406C14.3945 4.10155 14.4999 4.35596 14.5 4.62109V14.5C14.5 15.0523 14.0523 15.5 13.5 15.5H2.5C1.94772 15.5 1.5 15.0523 1.5 14.5V1.5C1.5 0.947715 1.94772 0.5 2.5 0.5Z",
					fill: "currentColor",
					fillOpacity: .25,
					stroke: "currentColor"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group 4",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Vector",
							d: "M4.27915 6.86077C4.41263 7.03634 4.58653 7.17709 4.78606 7.27106C4.98559 7.36503 5.20486 7.40943 5.42523 7.4005C6.1278 7.4005 6.69775 6.97304 6.69775 6.44626C6.69775 5.91949 6.1278 5.49203 5.42523 5.49203C4.72266 5.49203 4.15332 5.06456 4.15332 4.53717C4.15332 4.00978 4.72266 3.58293 5.42523 3.58293C5.64558 3.57416 5.86479 3.61863 6.0643 3.71259C6.2638 3.80654 6.43772 3.94721 6.5713 4.12266",
							stroke: "currentColor",
							strokeLinecap: "round",
							strokeLinejoin: "round"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_2",
							d: "M5.42493 7.40399V8.03994",
							stroke: "currentColor",
							strokeLinecap: "round",
							strokeLinejoin: "round"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_3",
							d: "M5.42493 2.95154V3.58687",
							stroke: "currentColor",
							strokeLinecap: "round",
							strokeLinejoin: "round"
						})
					]
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 16663",
					x: 3.9043,
					y: 9.72748,
					width: 8.19043,
					height: 1.25,
					rx: .625,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 16665",
					x: 3.9043,
					y: 11.9904,
					width: 8.19043,
					height: 1.25,
					rx: .625,
					fill: "currentColor"
				})
			]
		})
	})
});
export default SvgLoanStatements;
